import Timeslot from "components/molecules/Timeslot";
import React from "react";
import { PlaceholderBooking } from "placeholders";
import i18n from "utils/i18n";
import { AppRoutes } from "navigations/app-routes";
import _ from "lodash";
import store from "services/redux/store";
import ObjectLunchOption from "utils/objects/lunch-option";
import { dataConstants } from "services/redux/data/constants";
import { cartConstants } from "services/redux/cart/constants";
import ObjectBooking from "utils/objects/booking";
import { BookingCreateStyles } from 'styles/components/atoms/BookingCreate';
import Text from "theme/Text";
import ThemedBlock from 'components/atoms/ThemedBlock'
import HelperSetting from 'utils/helper-setting'
import { settingsConstants } from 'utils/constants/settings-constants'
import { View } from 'react-native'
import { timeslotKindConstants } from 'utils/constants/timeslot-kind-constants'
import { selectCartEmployees } from 'services/redux/cart/reducers'
import { bookingStatusActive } from 'utils/constants/booking-constants'

/**
 *
 * @param item
 * @param options
 * @returns {JSX.Element}
 */
export const RenderBookingCreateItem = ( item, options = {} ) => {
	
	// Create the (default) props
	const itemProps = {
		showCapacity: true,
		selectable: 'checkbox',
		selectableDisabled: false,
		...options
	};
	
	return (
		<View
			key={ 'booking-create-item-' + item.id }
			style={ BookingCreateStyles.calendarContainer }>
			
			<Timeslot
				item={ item }
				itemProps={ itemProps }
			/>
		</View>
	)
}

export const renderEmptyBookingCreateItem = ( isLoading ) => {
	if( isLoading ) {
		return (
			<PlaceholderBooking />
		)
	}
	
	return (
		<ThemedBlock shadow smallPadding>
			<Text
				style={ BookingCreateStyles.emptyText }>
				
				{ i18n.t('page.create.date.no_timeslot') }
			</Text>
		</ThemedBlock>
	);
};

export const cartHasPreAcceptedEmployees = () => {
	const _employee = store.getState().data[ dataConstants.EMPLOYEE ];
	const _cartEmployees = selectCartEmployees( store.getState() )
	const _employeeStatus = store.getState().cart[ cartConstants.EMPLOYEE_STATUS ];
	
	let result = false;
	_.forEach( _cartEmployees, employee => {
		if( employee.guid !== _employee.guid ) {
			const employeeStatus = _.get( _employeeStatus, employee.guid, null );
			
			// No status or not a active one?
			// Remove from the list
			if( employeeStatus !== null && bookingStatusActive.includes( employeeStatus ) ) {
				result = true;
			}
		}
	})
	
	return result;
}

/**
 * Function for checking where to navigate to
 * @returns {{navigateTo: string}}
 */
export const getNavigateToFromSelect = ( currentRoute, bookForMyself = true ) => {
	const _lunchOptions = store.getState().data[ dataConstants.LUNCH_OPTIONS ];
	const _cartTimeslotsLunch = _.filter( store.getState().cart[ cartConstants.TIMESLOTS ], ( o ) => {
		return o?.kind === timeslotKindConstants.LUNCH;
	});
	const _cartTimeslotsParking = _.filter( store.getState().cart[ cartConstants.TIMESLOTS ], ( o ) => {
		return o?.kind === timeslotKindConstants.TRANSPORT;
	});
	
	// Init the navigate to
	let navigateTo = AppRoutes.ADD_BOOKING_OVERVIEW;
	let label = i18n.t( 'page.create.date.validate_timeslots' );

	switch( true ) {
		//case currentRoute !== AppRoutes.ADD_BOOKING_LUNCH && ( bookForMyself || cartHasPreAcceptedEmployees() ) && !_.isEmpty( _lunchOptions ) && !_.isEmpty( _cartTimeslotsLunch ):
		case currentRoute !== AppRoutes.ADD_BOOKING_LUNCH && !_.isEmpty( _lunchOptions ) && !_.isEmpty( _cartTimeslotsLunch ):
			const allBookingLunchOptions = ObjectLunchOption.getOptionsByBookings( _cartTimeslotsLunch );

			if( _.size( allBookingLunchOptions ) > 0 ) {
				const didAlreadyBook = ObjectBooking.didAlreadyBook( _cartTimeslotsLunch );
				
				if( !didAlreadyBook ) {
					navigateTo = AppRoutes.ADD_BOOKING_LUNCH;
					label = i18n.t( 'page.create.date.select_lunch' );
				}
			}
			break;
			
		//case ( bookForMyself || cartHasPreAcceptedEmployees() ) && !_.isEmpty( _cartTimeslotsParking ) && HelperSetting.isYes( settingsConstants.BOOKING_ENABLE_PARKING_LICENSE_PLATE ):
		case !_.isEmpty( _cartTimeslotsParking ) && HelperSetting.isYes( settingsConstants.BOOKING_ENABLE_PARKING_LICENSE_PLATE ):
			const didAlreadyBook = ObjectBooking.didAlreadyBook( _cartTimeslotsParking );
			
			if( !didAlreadyBook ) {
				navigateTo = AppRoutes.ADD_BOOKING_LICENSE_PLATE;
				label = i18n.t( 'page.create.date.select_license_plate' )
			}
	}
	
	return {
		navigateTo: navigateTo,
		label: label
	}
}


